type Props = {
  value: string | number
  unfilteredValue?: string | number
}

export function BackofficeKnowledgeValue({ value, unfilteredValue }: Props) {
  return (
    <>
      {value}
      {unfilteredValue !== undefined && (
        <span className="ml-1 text-muted-foreground">
          {"("}
          {unfilteredValue}
          {")"}
        </span>
      )}
    </>
  )
}
